import { api } from './index'
import type { LoginForm, RegisterForm, AuthResponse, User } from '@/types/user'

export const authApi = {
  // 登录
  login: (credentials: LoginForm) =>
    api.post<AuthResponse>('/auth/login', credentials),

  // 注册
  register: (userData: RegisterForm) =>
    api.post<AuthResponse>('/auth/register', userData),

  // 退出登录
  logout: () =>
    api.post('/auth/logout'),

  // 刷新令牌
  refresh: (refreshToken: string) =>
    api.post<AuthResponse>('/auth/refresh', { refreshToken }),

  // 获取当前用户信息
  getProfile: () =>
    api.get<User>('/auth/profile'),
}